<template>
  <div class="popover-phone">
    <div class="card customer">
      <div class="title">客服咨询</div>
      <div class="phone">{{  peerCSData && peerCSData.mobile_phone }}</div>
      <div class="time">
        <span>{{working_time_list[0]}}</span>
        <span>{{working_time_list[1]}}</span>
      </div>
    </div>

    <div class="card supervise">
      <div class="title">质量监督</div>
      <div class="person-phone">17724727798(谢先生)</div>
      <div class="email">gaoyun.xie@idsuipai.com</div>
      <div class="time">
        <span>{{working_time_list[0]}}</span>
        <span>{{working_time_list[1]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState('config', [
      'customer_service',
    ]),
    ...mapState('user', [
      'peerCSData',
    ]),
    working_time_list() {
      const working_time = this.peerCSData ? this.peerCSData.working_time : this.customer_service.working_time;
      const working_time_list = working_time ? working_time.split(' ') : [];
      const work = working_time_list[0];
      working_time_list.splice(0, 1);
      const time = working_time_list.length ? working_time_list.join(' ') : '';
      return [work, time];
    },
  },
};
</script>

<style lang="less" scoped>
.popover-phone {
  padding: 0 15px 0 10px;
  .card {
    padding: 16px 0;
    border-bottom: 1px solid #E9EEF2;
    >div {
      white-space: nowrap;
    }
    &:last-child {
      border-bottom: none;
    }

    .title {
      font-size: 14px;
      color: #2F333D;
      line-height: 20px;
    }

    .time {
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      color: #5F666E;
      line-height: 14px;
    }
  }


  .customer {
    .phone {
      margin-top: 4px;
      font-weight: 600;
      font-size: 24px;
      color: #599FFF;
      line-height: 30px;
    }
  }

  .supervise {
    .person-phone {
      margin-top: 8px;
      font-weight: 600;
      font-size: 18px;
      color: #FF8033;
      line-height: 20px;
    }

    .email {
      font-weight: 600;
      font-size: 14px;
      color: #FF8033;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/popover/popover-phone.vue